module.exports = __webpack_public_path__ + "static/media/quiz-paper-filled-wine.2d8498d8.svg";